import { Injectable } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Language } from 'app/service/coreModel';
import { Observable, ReplaySubject } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private _currentLang = new ReplaySubject<string>(1);
  constructor(private _translateServ: TranslateService) { }

  initState() {
    const lang = localStorage.getItem('lang');
    this._translateServ.addLangs(Language.getCode());

    if (lang) {
      console.log(lang);
      this.setLang(lang);
    } else {
      const browserLang = (this._translateServ.getBrowserLang().includes('zh')) ? 'zh_hant' : 'en';
      this.setLang(browserLang);
    }
  }
  setLang(lang: string) {
    this._translateServ.onLangChange.pipe(take(1)).subscribe(res => {
      this._currentLang.next(res.lang);
    });

    this._translateServ.use(lang);
    localStorage.setItem('lang', lang);
  }

  getCurrentLang() {
    return this._translateServ.currentLang;
  }

  get(): ReplaySubject<string> {
    return this._currentLang;
  }
}
